import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=authed
  const [org, setOrg] = useState(null);

  const loadOrg = useCallback(async () => {
    try {
      const { data } = await api.get("/org");
      setOrg(data);
    } catch { /* ignore until authed */ }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        loadOrg();
      } catch {
        setUser(false);
      }
    })();
  }, [loadOrg]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    loadOrg();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const changePassword = async (current_password, new_password) => {
    await api.post("/auth/change-password", { current_password, new_password });
    setUser((u) => ({ ...u, must_change_password: false }));
  };

  const refreshUser = useCallback(async () => {
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { return null; }
  }, []);

  return (
    <AuthContext.Provider value={{ user, org, login, logout, loadOrg, changePassword, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
